import { render, staticRenderFns } from "./NewRole.vue?vue&type=template&id=6d51a6b0&scoped=true"
import script from "./NewRole.vue?vue&type=script&lang=js"
export * from "./NewRole.vue?vue&type=script&lang=js"
import style0 from "./NewRole.vue?vue&type=style&index=0&id=6d51a6b0&prod&lang=scss&scoped=true"
import style1 from "./NewRole.vue?vue&type=style&index=1&id=6d51a6b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51a6b0",
  null
  
)

export default component.exports